import {Kategoriservice} from "@/services/kategori.service";
import {AppMenuService} from "@/services/appmenu.service";

const state ={
    loading_kategori: false,
    loadingAddKategori: false,
    loadingMenu: false,
    kategori: [],
    listMenu: [],
    totaldata: 0,
    totalpage: 0
}

const actions ={
    getKategori({commit}, opsi){
        commit('setloading', true);
        commit('clearList');
        Kategoriservice.listKategori(opsi).then(value => {
            commit('setloading', false);
            commit('setkategori', value);
        }).catch(e=>{
            commit('setloading', false);
            console.log(e);
        });
    },
    Add({ dispatch, commit }, payload) {
        commit('setLoadingAddKategori', true);
        payload.kategoriData.sort =  Number(payload.kategoriData.sort)
        Kategoriservice.add(payload.kategoriData)
        .then(() => {
            dispatch('alert/success', 'Add data Successfully', { root: true });
            dispatch('getKategori', payload.opsi)
        }, error => {
            dispatch('alert/error', error, { root: true });
        })
    },
    Delete({ dispatch }, payload) {
        Kategoriservice.hapus(payload.id).then(() => {
            dispatch('alert/success', 'Delete data Successfully', { root: true });
            // commit('ShowAdd', data);
            dispatch("getKategori", payload.opsi)
        }, error => {
            dispatch('alert/error', error, { root: true });
        })
    },
    getMenuOnKategori({dispatch, commit}, ops) {
        AppMenuService.list(ops).then(data => {
            let menuResult = []
            data.data.content.forEach(element => {
                menuResult.push({text: element.label, value: element.id})
            });
            commit("setListMenu", menuResult)
            },  error => {
                dispatch('alert/error', error, { root: true });
            }
        )
    },
    Edit({ dispatch }, editdata) {
        Kategoriservice.edit(editdata.kategoriData)
        .then(() => {
            dispatch('alert/success', 'Edit data Successfully', { root: true });
            // commit('ShowAdd', data);
            dispatch("getKategori", editdata.opsi)
        }, error => {
            console.log(error)
            dispatch('alert/error', error, { root: true });
        })
    }
}

const mutations = {
    setloading(state,load){
        state.loading_kategori=load;
    },
    setLoadingAddKategori(state,load){
        state.loadingAddKategori=load;
    },
    clearList(state){
        state.kategori= []
    },
    setkategori(state, value){
        state.kategori=value.data;
        state.totaldata= value.data ? value.data.totalElements : 0;
        state.totalpage= value.data ? value.data.totalPages : 0;
    },
    setListMenu(state, value){
        state.listMenu = value
    },
    addResponseApp(state, apps) {
        state.kategori = []
        state.kategori = apps.data;
        state.totaldata=apps.data.totalElements;
        state.totalpage=apps.data.totalPages;
        state.loadingAddKategori = false;
    },
}


export const Kategori = {
    namespaced: true,
    state,
    actions,
    mutations
};
